// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

interface CheckoutSharedStyles {
    sectionTitle?: TypographyPresentationProps;
    subSectionTitle?: TypographyPresentationProps;
    headingAndTextStyles?: SmallHeadingAndTextStyles;
}

export const checkoutSharedStyles: CheckoutSharedStyles = {
    sectionTitle: {
        variant: "h3",
        forwardAs: "p",
        css: css`
            margin-bottom: 16px;
            width: 100%;
        `,
    },
    subSectionTitle: {
        variant: "h6",
        forwardAs: "p",
    },
    headingAndTextStyles: {
        extendedStyles: {
            wrapper: {
                css: css`
                    display: flex;
                    flex-direction: column;
                    row-gap: 12px;
                `,
            },
            heading: {
                lineHeight: "19px",
                weight: "bold",
                size: 14,
                transform: "capitalize",
            },
            text: {
                lineHeight: "22px",
                weight: "normal",
                size: 14,
            },
        },
    },
};
